import { Services } from "appworks/services/services";
import { TransactionService } from "appworks/services/transaction/transaction-service";
import { SignalBinding } from "signals";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";
import { IdleState } from "slotworks/state-machine/standard/states/idle-state";

export class GameiomIdle extends IdleState {
    protected signalBindings: SignalBinding[] = [];

    public onEnter(): void {
        super.onEnter();
        this.signalBindings.push(Services.get(SlotBetService).onBetChange.add(() => this.clearTotalWin()));
    }

    public onExit(): void {
        for (const binding of this.signalBindings) {
            binding.detach();
        }
        this.signalBindings = [];

        super.onExit();
    }

    protected clearTotalWin() {
        Services.get(TransactionService).setTotalWin(0);
    }
}
